<template>
    <div class="users-index position-relative">
        <portal
            to="layout-default-header"
            name="layout-default-header-black"
        >
            <b-row
                align-v="end"
                class="pt-5"
            >
                <b-col class="mb-3 mb-sm-0">
                    <h1 class="mb-0">
                        {{ $t('users.index.title') }}
                    </h1>
                </b-col>
            </b-row>
        </portal>

        <form-search
            class="mb-4 w-50"
            @setSearch="setUserSearch"
        />

        <div class="table-responsive">
            <users-table
                :loading="pos_loading"
                :rows="pos_rows"
                class="table-hover"
                @onRowClick="onRowClick"
            />
        </div>
    </div>
</template>

<script>
import Me from '@/library/Me';
import User from '@/models/User';
import Redirect from '@/library/Redirect';
import UsersTable from '@/components/users/Table';
import FormSearch from '@/components/common/form/Search';
import paginatesOnScroll from '@/library/mixins/paginatesOnScroll';

export default {
    name: 'UsersIndex',
    components: {FormSearch, UsersTable},
    mixins: [paginatesOnScroll],
    data() {
        return {
            User: User,
            d_me: new Me,
            pos_url: User.getEndpoint(),
        };
    },
    methods: {
        onRowClick(data) {
            Redirect.to({name: 'users.show', params: {id: data.row.id}});
        },
        pos_success({data}) {
            const rows = User.collect(data.data);

            this.pos_rows = [...this.pos_rows, ...rows];
        },
        setUserSearch(query) {
            this.pos_url = User.getEndpoint(User.getSearchFieldUrlQueries(query));
        },
    },
};
</script>
